// What Sell Tickets offers from evt.live's /api/stripe/payout-accounts answer
// (fetchPayoutAccounts in components/http/stripeLinks.js): the Stripe accounts
// the owner's other events already pay out to. evt.live decides what's
// allowed (eventlive-domain lib/stripeLinks/payoutAccounts.cjs); this only
// decides what to show.
//
// An account's kind: "own" when the owner connected it with their own Connect
// button, "client" when it came through a copied link, null when nobody knows
// (connected before October 2026, or confirmed by email).

// The owner's own accounts first, then older ones, then clients'.
export function accountsToOffer(data) {
  const accounts = Array.isArray(data?.accounts) ? data.accounts : [];
  const rank = (found) =>
    found.kind === "own" ? 0 : found.kind === "client" ? 2 : 1;
  return accounts
    .map((found, index) => ({ found, index }))
    .sort((a, b) => rank(a.found) - rank(b.found) || a.index - b.index)
    .map(({ found }) => found);
}

// A client's account, or one nobody knows the owner of, asks before it's
// used; the owner's own accounts apply at once.
export const asksBeforeUsing = (found) => !!found && found.kind !== "own";
